import { Mui, MuiIcons, MuiX } from "@osu/react-ui";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
// import { ActiveInactiveFilterToggle, BulkActivateDeactivateButton, BulkSaveToDbButton } from "./Buttons";
import ConfirmationDialog from "./ConfirmationDialog";
import { useGetReviewersQuery } from "../../services/graphql/api";
import useRoleAuthentication from "../../Authentication/hooks/useRoleAuthentication";
import { VISUALLY_HIDDEN_STYLE } from "../../util/styles";

export default function Reviewers() {
    const params = useParams();
    const isActive = params.active === "active";
    const isBulkEnabled = params.bulk === "bulk";
    
    const { isHonorsAdmin, isScholarsAdmin, isHonorsSeasonalManager } = useRoleAuthentication({ autoMode: true, redirectOnUnauthorized: true });
    const { isFetching, data } = useGetReviewersQuery({ isActive }, { refetchOnMountOrArgChange: true, skip: !isHonorsAdmin && !isScholarsAdmin && !isHonorsSeasonalManager });
    const { reviewers = [] } = data ?? {};
    
    const [selected, setSelected] = useState([]); // Datagrid data
    const [reviewersToConfirm, setShowConfirmationDialog] = useState([]); // Dialog data
    
    if (isFetching) { return ( <Mui.Skeleton height={200} aria-label="Loading reviewers" /> ); }

    return (
        <Mui.Box>
            <Mui.Box>
                <Mui.Paper style={{ padding: "2rem" }}>
                    {/* <Mui.Box style={{ margin: "0 0 1rem 0", textAlign: "right", }}>
                        <ActiveInactiveFilterToggle isActive={isActive} />

                        <BulkActivateDeactivateButton setSelected={setSelected} />
                        
                        <BulkSaveToDbButton reviewers={reviewers} selected={selected} showConfirmation={setShowConfirmationDialog} />
                    </Mui.Box> */}
                    
                    <MuiX.DataGrid
                        aria-label="Reviewers list"
                        autoHeight={true}
                        checkboxSelection={isBulkEnabled}
                        columns={getColumnDefinitions(setShowConfirmationDialog)}
                        disableSelectionOnClick
                        disableColumnFilter
                        isRowSelectable={ (params) => !params.row.isAdmin }
                        loading={isFetching}
                        slotProps={{ loadingOverlay: {
                            variant: "linear-progress", 
                            noRowsVariant: "skeleton"
                        }}}
                        localeText={{ noRowsLabel: "No reviewers found", noResultsOverlayLabel: "No reviewers found for filter" }}
                        onRowSelectionModelChange={setSelected}
                        rows={reviewers}
                        rowSelectionModel={selected}
                        sx={{ "& span.Mui-disabled": { display: "none" } }}
                    />
                </Mui.Paper>
            </Mui.Box>

            <ConfirmationDialog
                clear={() => setSelected([])}
                close={() => setShowConfirmationDialog([])}
                isActivating={!isActive}
                isBulk={isBulkEnabled}
                reviewersToConfirm={reviewersToConfirm} />
        </Mui.Box>
    );
}

function getColumnDefinitions(showDialogForId) {
    return [
        { field: "name", headerName: "Name", flex: 1, renderCell: renderNameLink },
        { field: "nameN", headerName: "Name.#", flex: 1 },
        { field: "experience", headerName: "Experience", flex: 1 },
        { field: "jobType", headerName: "Type", flex: 1 },
        { field: "groupType", headerName: "Group", flex: 1 },
        { field: "isAdmin", headerName: "Admin", flex: 1, renderCell: renderIsAdmin, type: "boolean" },
        // TODO Uncomment for ability to toggle active/inactive status
        // { field: "isActive", headerName: "Active", flex: 1, renderCell: renderActivateOption.bind(showDialogForId), type: "boolean" },
    ];
}

function renderNameLink(params) {
    return <Mui.Link component={Link} to={`/reviewer/${params.row.id}`}>{params.row.name}</Mui.Link>;
}

function renderIsAdmin(params) {
    const isAdmin = params.row.isAdmin;
    const adminStatus = isAdmin ? <MuiIcons.Check aria-hidden="true" /> : "";
    const screenReaderText = isAdmin ? "Yes" : "No";

    return (
        <Mui.Typography>
            {adminStatus}
            <span style={VISUALLY_HIDDEN_STYLE}>{screenReaderText}</span>
        </Mui.Typography>
    );
}
    
// eslint-disable-next-line
function renderActivateOption(params) {
    if (params.row.isAdmin) { return <Mui.Typography>Admin</Mui.Typography>; }

    const showDialogForId = this;
    const color = params.row.isActive ? "primary" : "secondary";

    return <Mui.Switch color={color} checked={params.row.isActive} onClick={ () => showDialogForId([params.row]) } />;
}
